import {
  Component,
  Input,
} from '@angular/core';

export type CtaMediaQuery = '' | '320';
export type CtaRole = '' | 'alternate' | 'alternate-dark' | 'primary' | 'optional' | 'link';
export type CtaSize = '' | 'lg' | 'm' | 'sm' | 'xs' | 'default' | 'full';
export type CtaType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'ula-cta-button',
  templateUrl: './cta-button.component.html',
  styleUrls: [ './cta-button.component.css' ]
})
export class CtaButtonComponent {
  @Input() icon: string;
  @Input() media: CtaMediaQuery = '';
  @Input() role: CtaRole = '';
  @Input() size: CtaSize = '';
  @Input() type: CtaType = 'submit';
  @Input() isDisabled: boolean = false;
  @Input() isLoading: boolean = false;

  public onClick(event: any): boolean {
    if (!this.isDisabled && !this.isLoading) {
      return true;
    } else {
      event.stopPropagation();
      return false;
    }
  }
}
